module.exports = __webpack_public_path__ + "static/img/mem.21840acf.png";